export function assertNever(v: never) {
  return v;
}
